<app-loader [loaded]="loaded" [progress]="loadingProgress"></app-loader>
<app-nav></app-nav>
<app-ui-menu></app-ui-menu>
<app-embed-menu></app-embed-menu>
<div id="eventDisplay"></div>
